module.exports = __webpack_public_path__ + "img/banner2.6720dc5.png";